<template>
    <ModalComponent
        :name="name"
        title="Descargar envios"
        v-on:close="() => close(false)"
    >
        <template v-if="!descarga">            
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <div v-if="!noEnvios">
                            <select class="custom-select w-auto mb-3" v-model="tipo_fecha">
                                <option value="fecha_pedido">FECHA DEL PEDIDO</option>
                                <option value="fecha_envio">FECHA DEL ENVÍO</option>
                            </select>
                            <div class="form-group">
                                <label for="fecha_envio">Fecha de inicio</label>
                                <datetime 
                                    v-model="fecha_inicio"
                                    input-class="form-control"
                                    type="date"
                                    input-id="fecha_inicio"
                                />
                            </div>
                            <div class="form-group">
                                <label for="fecha_envio">Fecha de fin</label>
                                <datetime 
                                    v-model="fecha_fin"
                                    input-class="form-control"
                                    type="date"
                                    input-id="fecha_fin"
                                />
                            </div>
                            <Button @click="getInforme()">DESCARGAR</Button>
                        </div>
                        <h3 v-else>No hay envios</h3>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <DescargarEnvios :descarga="descarga" @close="close()" />
        </template>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import DescargarEnvios from "./DescargarEnvios.vue";

    export default {
        props: ['name', 'searchParams'],
        data() {
            return {
                loading: false,
                descarga: null,
                noEnvios: false,
                fecha_inicio: null,
                fecha_fin: null,
                tipo_fecha: 'fecha_pedido',
            }
        },
        methods: {
            close() {
                this.descarga = null;
                this.noEnvios = false;
                this.fecha_inicio = null;
                this.fecha_fin = null;
                this.tipo_fecha = 'fecha_pedido';
                this.$emit('close', this.name);
            },
            getInforme() {
                this.searchParams.fecha_inicio = this.fecha_inicio;
                this.searchParams.fecha_fin = this.fecha_fin;
                this.searchParams.tipo_fecha = this.tipo_fecha;
                this.tid = this.configuracion.hash_teatro;
                let params = {
                    filters: this.searchParams,
                    tid : this.configuracion.hash_teatro
                };
                this.$store.dispatch(this.config.getVuexAlias('back.envios.descargar_excel'), params).then(res => {
                    this.descarga = res.data.descargar;
                    delete this.searchParams.fecha_inicio;
                    delete this.searchParams.fecha_fin;
                    delete this.searchParams.tipo_fecha;
                }).catch(() => {
                    this.noEnvios = true;
                });
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        components: {
            ModalComponent, DescargarEnvios
        }
    }
</script>
